import React from 'react';
import classnames from 'classnames';
import { Pane, Text } from '@leverege/ui-elements';
import StringUtil from '@leverege/string-util';
import { WeeklyHours } from '@leverege/operating-hours';
import I18N from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import DailyHoursEditor from "./DailyHoursEditor.js";
import { DAYS } from "./Constants.js";
import S from './WeeklyHoursEditor.css';
const {
  t
} = I18N.ns('imagine.operatingHours.WeeklyHoursEditor');
export default function WeeklyHoursEditor(props) {
  const {
    value
  } = props;
  const onChange = useValueChange(WeeklyHours, props);
  return /*#__PURE__*/React.createElement(Pane, {
    variant: "operatingHoursWeeklyGrid",
    className: S.container
  }, /*#__PURE__*/React.createElement(Pane, {
    variant: "operatingHoursWeeklyGridHeader",
    className: classnames(S.grid, S.thead)
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Text, {
    variant: "openingHoursHeader"
  }, t('open')), /*#__PURE__*/React.createElement(Text, {
    variant: "openingHoursHeader"
  }, t('openingTime')), /*#__PURE__*/React.createElement(Text, {
    variant: "openingHoursHeader"
  }, t('closingTime')), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(Pane, {
    className: S.body,
    variant: "operatingHoursWeeklyGridBody",
    layout: "flex:col"
  }, DAYS.map((day, index) => {
    const dayName = StringUtil.capitalize(day);
    return /*#__PURE__*/React.createElement(DailyHoursEditor, {
      index: index,
      key: day,
      eventData: `set${dayName}`,
      value: WeeklyHours[`get${dayName}`](value),
      onChange: onChange
    });
  })));
}